import apiSlice from "./ApiSlice";

const offlineOrderApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all order dates
    getAllOfflineOrderData: builder.query({
      providesTags: ["offline-order"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/order",
          method: "POST",
          body,
        };
      },
    }),

    //get all leadger by frabnchise 

    getAllLedger: builder.query({
      providesTags: ["offline-order"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/ledger",
          method: "POST",
          body,
        };
      },
    }),

    // get single order view
    getSingleOfflineOrderData: builder.query({
      providesTags: ["offline-order"],
      query: (id: any) => {
        return {
          url: `/order/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateOrderById: builder.mutation({
      invalidatesTags: ["offline-order"],
      query: ({ body, id }) => ({
        url: `/order/${id}`,
        method: "PUT",
        body,
      }),
    }),
    
    // update delivery date
    updateOrderPaymentById: builder.mutation({
      invalidatesTags: ["offline-order"],
      query: ({ body, id }) => ({
        url: `/order/payment-update/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // delete delivery date
    deleteOfflineOrderById: builder.mutation({
      invalidatesTags: ["offline-order"],
      query: ({body,id}) => ({
        url: `/order/${id}`,
        method: "DELETE",
        body
      }),
    }),
    // add delivery date
    addOfflineOrder: builder.mutation({
      invalidatesTags: ["offline-order"],
      query: (body) => ({
        url: `/order/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getOfflineOrderById: builder.query({
      providesTags: ["offline-order"],
      query: (id: string) => {
        return {
          url: `/offline-order/${id}`,
          method: "GET",
        };
      },
    }),

     //get delivery date by Id
     getLedgerBalance: builder.query({
      providesTags: ["offline-order"],
      query: (id: string) => {
        return {
          url: `/ledger/${id}/balance`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateOfflineOrderById: builder.mutation({
      invalidatesTags: ["offline-order"],
      query: ({ body, id }) => ({
        url: `/offline-order/${id}`,
        method: "PUT",
        body,
      }),
    }),
    updateBookOrderById: builder.mutation({
      invalidatesTags: ["offline-order"],
      query: ({ body, id }) => ({
        url: `/order/books/${id}`,
        method: "PUT",
        body,
      }),
    }),
    updateDueOrderById: builder.mutation({
      invalidatesTags: ["due"],
      query: ({ body, id }) => ({
        url: `/order/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusOfflineOrderById: builder.mutation({
      invalidatesTags: ["offline-order"],
      query: ({ body, id }) => ({
        url: `/offline-order/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
    getAdvancePayment: builder.mutation({
      invalidatesTags: ["offline-order"],
      query: (body) => {
        return {
          url: `/advance-payment/get-total`,
          method: "POST",
          body
        };
      },
    }),

  }),
});

export const {
  useGetAllOfflineOrderDataQuery,
  useDeleteOfflineOrderByIdMutation,
  useGetLedgerBalanceQuery,
  useAddOfflineOrderMutation,
  useGetOfflineOrderByIdQuery,
  useGetAllLedgerQuery,
  useUpdateOfflineOrderByIdMutation,
  useChangeStatusOfflineOrderByIdMutation,
  useUpdateOrderByIdMutation,
  useUpdateOrderPaymentByIdMutation,
  useGetAdvancePaymentMutation,
  useGetSingleOfflineOrderDataQuery,
  useUpdateBookOrderByIdMutation,
  useUpdateDueOrderByIdMutation
} = offlineOrderApi;
